/**
 * @generated SignedSource<<269bb8fcf60a3219d78926d98f06e0a3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LocationFields_User$data = {
  readonly profile: {
    readonly fullAddress: string | null | undefined;
    readonly locationBounds0: number | null | undefined;
    readonly locationBounds1: number | null | undefined;
    readonly locationBounds2: number | null | undefined;
    readonly locationBounds3: number | null | undefined;
    readonly locationLatitude: number | null | undefined;
    readonly locationLongitude: number | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "LocationFields_User";
};
export type LocationFields_User$key = {
  readonly " $data"?: LocationFields_User$data;
  readonly " $fragmentSpreads": FragmentRefs<"LocationFields_User">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LocationFields_User",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Profile",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "locationBounds0",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "locationBounds1",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "locationBounds2",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "locationBounds3",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "locationLatitude",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "locationLongitude",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fullAddress",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "9815adda34f79d0ee17bd719fb3ad5b7";

export default node;
